<template>
    <!-- 报表管理－销售门票统计 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'ticketSellStatistics')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="日期">
                        <a-date-picker
                            style="width:282px"
                            format="YYYY/MM/DD"
                            v-decorator="['startTime',{initialValue: $moment()}]"
                            @change="onChangeDate"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button @click="getList" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>

            <div class="container">
                <a-table
                    :bordered="true"
                    :dataSource="dataSource"
                    :columns="columns"
                    :pagination="false"
                    :rowKey="(record,index) => index"
                >
                </a-table>
            </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex"
    const columns = [
        {
            title: "票券内部标识",
            dataIndex: "ticketName"
        },
        {
            title: "票券展示名称",
            dataIndex: "ticketShowName"
        },
        {
            title: "销售张数（张）",
            dataIndex: "count"
        },
    ];
    export default {
        name: "ticketSellStatistics",
        components: {},
        props: {},
        data() {
            return {
                dataSource: [],
                columns,
            };
        },
        watch: {
            $route: function(newVal, oldVal) {
                if (newVal.name === "ticketSellStatistics") {
                    this.getList();
                }
            },
            shopId() {
                this.getList();
            }
        },
        methods: {
            onChangeDate() {
                setTimeout(() => {
                    this.getList()
                },100)
            },
            //重置
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            //获取列表 
            getList() {
                if(!this.shopId) return
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.$api.statement
                        .ticketSellNumDay({
                            body: {
                                platform: '收银台',
                                shopId: this.shopId,
                                startDate: values.startTime ? values.startTime.format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD'),
                                endDate: values.startTime ? values.startTime.format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD'),
                            }
                        })
                        .then(res => {
                            this.dataSource = res.length > 0 ? res[0].list : [];
                        });
                });
            },
        }, 
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
        },
        computed: {
            ...mapGetters(["shopId"])
        },
    };
</script>
<style lang="scss" scoped>
    .container {
        background: #fff;
    }
</style>